/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import React from 'react';
import 'match-media';
import 'typeface-roboto';
import 'typeface-roboto-slab';

// Components
import LdMetadataHelmet from './src/components/LdMetadataHelmet';

// Contexts.
import { AnalyticsProvider } from './src/contexts/AnalyticsContext/';
import { KitActivationFormContextProvider } from './src/contexts/KitActivationFormContext';
import { UserSessionProvider } from './src/contexts/UserSessionContext';

export const onClientEntry = () => {
  // IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`);
  }
};
export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <LdMetadataHelmet />
  </>
);

export const wrapRootElement = ({ element, props }) => {
  if (
    window.location.href.match(
      /http(s?):\/\/(seq.docker.localhost|sequencing.com)\/tests\/web-performance\/011/
    )
  ) {
    return <>{element}</>;
  }

  return (
    <UserSessionProvider>
      <AnalyticsProvider>
        <KitActivationFormContextProvider>
          {element}
        </KitActivationFormContextProvider>
      </AnalyticsProvider>
    </UserSessionProvider>
  );
};
